var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view order-detail" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "show-left": _vm.orderArr.length > 1,
            "left-style": { width: "15%", paddingTop: "10px" },
            "right-style": { width: "85%" }
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-card",
                { attrs: { shadow: "never" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v("订单号")])
                  ]),
                  _c(
                    "el-menu",
                    {
                      staticStyle: { border: "none" },
                      attrs: { "default-active": _vm.orderUuid }
                    },
                    _vm._l(_vm.orderArr, function(item) {
                      return _c(
                        "el-menu-item",
                        {
                          key: item.uuid,
                          attrs: { index: item.uuid },
                          on: {
                            click: function($event) {
                              return _vm.handleOrderChange(item)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(item.poNo))]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isLook,
                      expression: "!isLook"
                    }
                  ],
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-left": "0px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.editBack }
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.doSave }
                        },
                        [_vm._v("保存")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLook,
                      expression: "isLook"
                    }
                  ],
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "padding-left": "0px",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.toBackList }
                        },
                        [_vm._v("返回")]
                      ),
                      _vm.orderState !== 1 && _vm.orderState !== -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetail(_vm.orderUuid, 3)
                                }
                              }
                            },
                            [_vm._v("编辑")]
                          )
                        : _vm._e(),
                      _vm.orderState !== 1 && _vm.orderState !== -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.handleCancelOrder }
                            },
                            [_vm._v("取消")]
                          )
                        : _vm._e(),
                      _vm.orderState !== 1
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                disabled: !_vm.$checkPermission([
                                  "button_OrderManage_delete"
                                ])
                              },
                              on: { click: _vm.handleDelOrder }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                      _vm.orderState === -1
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.$checkPermission([
                                  "button_OrderManage_renew"
                                ])
                              },
                              on: { click: _vm.handleRenewOrder }
                            },
                            [_vm._v("恢复")]
                          )
                        : _vm._e(),
                      _vm.orderState !== 1 && _vm.orderState !== -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.packageImportVisible = true
                                }
                              }
                            },
                            [_vm._v("导入包装")]
                          )
                        : _vm._e(),
                      _vm.orderState !== 1 && _vm.orderState !== -1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSplitOrder }
                            },
                            [_vm._v("拆单")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.orderState !== null
                    ? _c("div", [
                        _vm.orderState === -1
                          ? _c("span", [_vm._v("已取消")])
                          : _vm._e(),
                        _vm.orderState === 0
                          ? _c("span", [_vm._v("正操作")])
                          : _vm._e(),
                        _vm.orderState === 1
                          ? _c("span", [_vm._v("已完成")])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "tabs-container",
                  staticStyle: { "margin-top": "5px" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "基础信息", name: "basic" } },
                        [
                          _c("base-info", {
                            ref: "baseInfo",
                            attrs: {
                              "order-uuid": _vm.orderUuid,
                              "opration-type": _vm.oprationType
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("import-dialog", {
        attrs: {
          title: "批量导入包装",
          action: _vm.URL.order.importPoPackage,
          visible: _vm.packageImportVisible,
          "folder-name": "booking",
          "file-name": "包装导入模板.xlsx"
        },
        on: {
          onClose: function($event) {
            _vm.packageImportVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }